import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import ClearIcon from "@mui/icons-material/Clear";
import { IconButton } from "@mui/material";
import mainLogo from "../../../assets/images2/logo.png";
import { useNavigate } from "react-router-dom";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  padding: "20px",
  borderRadius: "14px",
};

const TournamentModal = ({ open, setOpen, edit, data }) => {
  const navigate = useNavigate();
  return (
    <>
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="add-tournament-modal">
          <Box sx={{ display: "flex", width: "100%", justifyContent: "end" }}>
            <IconButton
              onClick={() => {
                setOpen(false);
                // navigate("/myaccount/3");
                navigate(`/viewClub/${data?.id}`);
              }}
            >
              <ClearIcon />
            </IconButton>
          </Box>
          <Box className="icon-div">
            <div className="img-div">
              <img src={mainLogo} alt="logo" className="img_fluid" />
            </div>
          </Box>
          <Box className="text">
            <Typography component="h1" sx={{ mt: 2 }}>
              {edit
                ? "club updated Successfully"
                : "club created Successfully!"}
            </Typography>
            <Typography component="p">
              {edit
                ? "Your club has been updated."
                : "Your club has been started."}
            </Typography>
          </Box>
          <Button
            className="custom-button"
            onClick={() => {
              setOpen(false);
              // navigate("/myaccount/3");
              navigate(`/viewClub/${data.id}`);
            }}
          >
            View now
          </Button>
        </Box>
      </Modal>
    </>
  );
};

export default TournamentModal;
